import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Constants } from './../../shared/constants';
import { StorageService } from './../../shared/services/storage.service';


@Injectable({
    providedIn: 'root'
})

export class ContactUsService {

    constructor(private http: HttpClient) { }


    // Get ContactUs/ContactReason from Jamestown GET Request
    getContactUs(): Observable<any> {
        return this.http.get(`${Constants.baseURL}/contactUs/contactReasons`);
    }

    // Submit contact form
    submitContact(body: any): Observable<any> {
        return this.http.post(`${Constants.baseURL}/contactUs`, body);
    }

}
